import AlertDisplay from './AlertDisplay';

export default AlertDisplay;
export * from './AlertDisplay';
